{ "amp": "&", "apos": "'", "gt": ">", "lt": "<", "quot": "\"" }
